/* eslint-disable */
export default {
  logging: 'Protokollierung...',
  logCall: 'Anruf protokollieren',
  editLog: 'Protokoll bearbeiten',
  select: 'Datens. auswähl.',
  OnHold: 'Wird gehalten',
  Ringing: 'Läutet',
  CallConnected: 'Anruf verbunden',
  unknownUser: 'Unbekannter Benutzer',
  unknownNumber: 'Anonym',
  unavailable: 'Nicht verfügbar',
  viewDetails: 'Details anzeigen',
  conferenceCall: 'Telefonkonferenz',
  callerId: 'Anrufer-ID',
} as const;

// @key: @#@"logging"@#@ @source: @#@"Logging..."@#@
// @key: @#@"logCall"@#@ @source: @#@"Log Call"@#@
// @key: @#@"editLog"@#@ @source: @#@"Edit Log"@#@
// @key: @#@"select"@#@ @source: @#@"Select record"@#@
// @key: @#@"OnHold"@#@ @source: @#@"On Hold"@#@
// @key: @#@"Ringing"@#@ @source: @#@"Ringing"@#@
// @key: @#@"CallConnected"@#@ @source: @#@"Call Connected"@#@
// @key: @#@"unknownUser"@#@ @source: @#@"Unknown User"@#@
// @key: @#@"unknownNumber"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"unavailable"@#@ @source: @#@"Unavailable"@#@
// @key: @#@"viewDetails"@#@ @source: @#@"View Details"@#@
// @key: @#@"conferenceCall"@#@ @source: @#@"Conference Call"@#@
// @key: @#@"callerId"@#@ @source: @#@"Caller ID"@#@
